/*
 * Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
 *
 * This SOURCE CODE FILE, which has been provided by Certusoft as part
 * of a Certusoft product for use ONLY by licensed users of the product,
 * includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
 *
 * USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
 * OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
 * THE PRODUCT.
 */

import * as _ from 'lodash'
import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { UserSessionService } from '../../services/user-session.service'

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.less'],
})
export class ProfileComponent implements OnInit {
    constructor(private Session: UserSessionService) {}

    public accounts: string[] = []

    ngOnInit(): void {
        this.accounts = _.map(this.Session.crmAccounts, function (acc) {
            return JSON.stringify(acc, null, 4)
        })
    }
}
